<template>
    <div class="newsSetting">
        <div class='headerSerc-item'>
            <span>{{setTingObj.bgColor.title}}</span>
            <color :colorObj="setTingObj.bgColor"></color>
        </div>
        <div class='headerSerc-item'>
            <span>{{setTingObj.themeColor.title}}</span>
            <color :colorObj="setTingObj.themeColor"></color>
        </div>
        <div class='headerSerc-item'>
            <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
            <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
        </div>
        <div class='headerSerc-item'>
            <span>{{setTingObj.prConfig.title}}</span>
            <sliderAndInput :lrConfig="setTingObj.prConfig"></sliderAndInput>
        </div>
        <div class='headerSerc-item'>
            <span>{{setTingObj.mbConfig.title}}</span>
            <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
        </div>
    </div>
</template>

<script>

import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import color from '@/components/decoration/common/color.vue';
import radio from '@/components/decoration/common/radio.vue';

export default {
    components: { radio, color, sliderAndInput },
    data() {
        return {};
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    methods: {
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
    }
};
</script>

<style scoped lang="scss">
.newsSetting{
    padding: 0 5px;
}
</style>